// 须置于首行，在 react-dom 初始化前拦截开发环境控制台噪音
import './suppressDevConsoleNoise';

import './styles/ipe/ipe-theme.css';
import './styles/common/scrollbar-global.css';
import './styles/shared/modal-footer-confirm-button.css';

//项目的入口，从这里开始

//React必要两个核心包
import React from 'react';
import ReactDOM from 'react-dom/client';

//导入组件
import App from './App';
import { AuthProvider } from './context/AuthContext';
import IpeI18nProvider from './i18n/IpeI18nProvider';
import { installModalBackdropDismiss } from './utils/installModalBackdropDismiss';

installModalBackdropDismiss();

//把app组件渲染到id为root的节点上
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <IpeI18nProvider>
    <AuthProvider>
      <App />
    </AuthProvider>
  </IpeI18nProvider>
);
